import {
	Button,
	Card,
	Col,
	DatePicker,
	Form,
	Input,
	InputNumber,
	Modal,
	Popconfirm,
	Radio,
	Row,
	Select,
	Tag,
	Tooltip,
	Typography,
} from "antd";
import { EditOutlined, RobotOutlined, DollarOutlined, PlusOutlined } from "@ant-design/icons";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllCustomer } from "../../redux/actions/customer/getCustomerAction";
import { loadProduct } from "../../redux/actions/product/getAllProductAction";
import { loadAllProductCurrency } from "../../redux/actions/productCurrency/getProductCurrencyAction";
import { addSale } from "../../redux/actions/sale/addSaleAction";
import Products from "./Products";
import BillUpload from "./BillUpload";
import AddCust from "../customer/addCust";

import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loadAllStaff } from "../../redux/actions/user/getStaffAction";
import { loadAllSale } from "../../redux/actions/sale/getSaleAction";
import { getSalesOrderById, createSalesOrder } from "../../redux/actions/sale/salesOrderAction";
import { getPurchaseOrderById } from "../../redux/actions/purchase/purchaseOrderAction";
import axios from "axios";
import getSetting from "../../api/getSettings";
import {
	confirmMasterListPriceSyncThen,
	getReferenceListPriceFromProduct,
} from "../../utils/productListPriceSync";
import "./sale.css";

const { Title } = Typography;
const DEFAULT_DOCUMENT_PREFIXES = {
	sale: "INV/25-26/",
	quotation: "QTN/25-26/",
	challan: "CHL/25-26/",
	sales_order: "SO/25-26/",
};

const AddSale = () => {
	const { Option } = Select;
	const [formData, setFormData] = useState({});
	const [loader, setLoader] = useState(false);

	const navigate = useNavigate();
	const location = useLocation();
	const [conversionContext, setConversionContext] = useState(null);
	const [isPrefilledFromSource, setIsPrefilledFromSource] = useState(false);
	const [selectedProds, setSelectedProds] = useState([]);
	const [showBillUpload, setShowBillUpload] = useState(false);
	const [addCustomerModalVisible, setAddCustomerModalVisible] = useState(false);
	const [customerSearchValue, setCustomerSearchValue] = useState('');
	const [extractedData, setExtractedData] = useState(null);

	const onClickLoading = () => {
		setLoader(true);
	};

	const [date, setDate] = useState(moment());

	const [startdate, setStartdate] = useState(moment().startOf("month"));
	const [enddate, setEnddate] = useState(moment().endOf("month"));

	const allSales = useSelector((state) => state.sales.list);
	const [invoiceNum, setInvoiceNum] = useState(1);
	const [preInvoiceText, setPreInvoiceText] = useState('');
	const [selectedSeriesId, setSelectedSeriesId] = useState(null);
	const [documentSeriesByType, setDocumentSeriesByType] = useState({
		sale: [],
		quotation: [],
		challan: [],
	});
	// Prefix editing removed: controlled via document series selection.
	const [allInvoicesForNumbering, setAllInvoicesForNumbering] = useState([]);
	const [discountType, setDiscountType] = useState("item");
	const [discount, setDiscount] = useState(0);
	const [globalDiscountValue, setGlobalDiscountValue] = useState("");
	const [globalQuantityValue, setGlobalQuantityValue] = useState("");

	const [afterDiscount, setAfterDiscount] = useState(0);
	const [afterProductDiscount, setAfterProductDiscount] = useState(0);

	// Additional Discount states (similar to purchase invoice)
	const [discountAmount, setDiscountAmount] = useState("");
	const [additionalDiscount, setAdditionalDiscount] = useState("");

	// Round Off states
	const [roundOffEnabled, setRoundOffEnabled] = useState(false);
	const [roundOffAmount, setRoundOffAmount] = useState(0);
	const dispatch = useDispatch();

	const allCustomer = useSelector((state) => state.customers.list);
	const allProducts = useSelector((state) => state.products.list);
	const allStaff = useSelector((state) => state.users.list);
	const allCurrencies = useSelector((state) => state.productCurrencies?.list);
	const globalSearchResults = useSelector((state) => state.products?.globalSearchResults);
	const [form] = Form.useForm();

	// Local state for currency conversion rates (session-specific overrides)
	const [currencyConversions, setCurrencyConversions] = useState({});

	// State for currency edit modal
	const [currencyEditModalVisible, setCurrencyEditModalVisible] = useState(false);
	const [editingCurrency, setEditingCurrency] = useState(null);
	const [currencyForm] = Form.useForm();

	// Helper function to get conversion rate based on invoice date and rate history
	const getConversionRate = (currencyId, defaultConversion, currency) => {
		// Check for local override first
		if (currencyConversions[currencyId] !== undefined) {
			return currencyConversions[currencyId];
		}

		// If currency has rate history and invoice date is set, find the appropriate rate
		if (currency && currency.currency_rates && currency.currency_rates.length > 0 && date) {
			const invoiceDate = moment(date);
			// Find the rate that is effective for the invoice date
			// (effective_from_date <= invoice date, and is the most recent one)
			const effectiveRate = currency.currency_rates
				.filter(rate => moment(rate.effective_from_date).isSameOrBefore(invoiceDate))
				.sort((a, b) => moment(b.effective_from_date).diff(moment(a.effective_from_date)))[0];

			if (effectiveRate) {
				return effectiveRate.conversion;
			}
		}

		// Fallback to default conversion or currency's conversion field
		return defaultConversion || currency?.conversion || 1;
	};

	// Get effective currencies based on invoice date
	const getEffectiveCurrencies = () => {
		if (!allCurrencies || !date) return allCurrencies || [];
		const invoiceDate = moment(date);
		return allCurrencies.filter(currency => {
			if (!currency.effective_from_date) return true; // No date restriction
			const effectiveDate = moment(currency.effective_from_date);
			return invoiceDate.isSameOrAfter(effectiveDate);
		});
	};

	// Handle currency edit
	const handleEditCurrency = (currency) => {
		setEditingCurrency(currency);
		currencyForm.setFieldsValue({
			name: currency.name,
			symbol: currency.symbol,
			conversion: currency.conversion || 1,
			effective_from_date: currency.effective_from_date ? moment(currency.effective_from_date) : null
		});
		setCurrencyEditModalVisible(true);
	};

	// Handle currency form submit
	const handleCurrencyFormSubmit = async () => {
		try {
			const values = await currencyForm.validateFields();
			// Update currency via API
			const response = await axios.put(`product-Currency/${editingCurrency.id}`, {
				...values,
				effective_from_date: values.effective_from_date ? values.effective_from_date.format('YYYY-MM-DD') : null
			});

			// Reload currencies
			dispatch(loadAllProductCurrency({ page: 1, limit: 100 }));
			setCurrencyEditModalVisible(false);
			setEditingCurrency(null);
			currencyForm.resetFields();
			toast.success('Currency updated successfully');
		} catch (error) {
			console.error('Error updating currency:', error);
			toast.error('Failed to update currency');
		}
	};

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const salesOrderIdParam = params.get("sales_order_id");
		const purchaseOrderIdParam = params.get("purchase_order_id");

		// Handle sales order selection – clear product list first to avoid extra/duplicate row, wait for allProducts like PO
		if (salesOrderIdParam) {
			setSalesOrderId(salesOrderIdParam);
			setPurchaseOrderId(null);
			setSelectedProds([]);
			form.setFieldsValue({ saleInvoiceProduct: [] });
			if (allProducts?.length > 0) {
				dispatch(getSalesOrderById(salesOrderIdParam)).then((result) => {
					if (result?.order) {
						prefillFromSalesOrder(result.order);
					}
				});
			}
			return;
		}

		// Handle purchase order selection (Convert to Invoice from PO) – clear product list first
		if (purchaseOrderIdParam) {
			setPurchaseOrderId(purchaseOrderIdParam);
			setSalesOrderId(null);
			setSelectedProds([]);
			form.setFieldsValue({ saleInvoiceProduct: [] });
			if (allProducts?.length > 0) {
				dispatch(getPurchaseOrderById(purchaseOrderIdParam)).then((result) => {
					if (result?.order) {
						prefillFromPurchaseOrder(result.order);
					}
				});
			}
			return;
		}

		const sourceType = params.get("sourceType");
		const idsParam = params.get("sourceIds") || params.get("sourceId");

		if (sourceType && idsParam) {
			const parsedIds = idsParam
				.split(",")
				.map((value) => Number(value.trim()))
				.filter((num) => !Number.isNaN(num));

			if (parsedIds.length) {
				const docTypesParam = params.get("docTypes");
				const docTypes = docTypesParam
					? docTypesParam.split(",").map((t) => (t || "sale").trim())
					: parsedIds.map(() =>
							["sale", "quotation", "challan", "saleList"].includes(sourceType)
								? sourceType === "saleList"
									? "sale"
									: sourceType
								: sourceType
					  );

				const nextContext = {
					type: sourceType,
					id: parsedIds[0],
					ids: parsedIds,
					docTypes,
					raw: `${idsParam}|${docTypesParam || sourceType}`,
				};

				const hasChanged =
					!conversionContext ||
					conversionContext.type !== nextContext.type ||
					conversionContext.raw !== nextContext.raw;

				if (hasChanged) {
					setConversionContext(nextContext);
					setIsPrefilledFromSource(false);
				}
				return;
			}
		}

		if (conversionContext) {
			setConversionContext(null);
			setIsPrefilledFromSource(false);
		}
		if (!purchaseOrderIdParam) {
			setPurchaseOrderId(null);
		}
	}, [location.search, allProducts?.length]);

	// Prefill from purchase order (Convert to Invoice from PO)
	const prefillFromPurchaseOrder = (order) => {
		if (!order || !order.order_items || !allProducts?.length) return;
		const products = order.order_items
			.map((item) => {
				const product = allProducts.find((p) => p.id === item.product_id);
				if (!product) return null;
				const remainingQty = item.ordered_quantity - (item.received_quantity || 0);
				if (remainingQty <= 0) return null;
				return {
					...product,
					selectedQty: remainingQty,
					sale_price: product.sale_price ?? item.purchase_price ?? 0,
					sale_disc: item.discount || 0,
					reference_list_price: getReferenceListPriceFromProduct(product),
				};
			})
			.filter(Boolean)
			.map((p, index) => ({ ...p, key: index }));
		const formProducts = products.map((p) => ({
			product_id: p.id,
			product_quantity: p.selectedQty || 1,
			product_sale_price: p.sale_price ?? 0,
			product_sale_discount: p.sale_disc || 0,
			product_name: p.name || "",
		}));
		setSelectedProds(products);
		if (formProducts.length > 0) {
			form.setFieldsValue({ saleInvoiceProduct: formProducts });
		}
	};

	// Prefill from sales order
	const prefillFromSalesOrder = (order) => {
		if (!order) return;
		setOrderNum(order.order_number || "");
		setOrderDate(order.order_date ? moment(order.order_date) : null);
		setCustomer(order.customer_id);
		setSalesPerson(order.user_id);
		form.setFieldsValue({
			customer_id: order.customer_id,
			sales_person_id: order.user_id,
		});

		// Prefill products from order items (only remaining quantities) – set form synchronously with index-based keys
		if (order.order_items && allProducts?.length > 0) {
			const products = order.order_items
				.map((item) => {
					const product = allProducts.find((p) => p.id === item.product_id);
					if (!product) return null;
					const remainingQty = item.ordered_quantity - (item.fulfilled_quantity || 0);
					if (remainingQty <= 0) return null;
					return {
						...product,
						selectedQty: remainingQty,
						sale_price: item.sale_price,
						sale_disc: item.discount || 0,
						reference_list_price: getReferenceListPriceFromProduct(product),
					};
				})
				.filter(Boolean)
				.map((p, index) => ({ ...p, key: index }));
			const formProducts = products.map((p) => ({
				product_id: p.id,
				product_quantity: p.selectedQty || 1,
				product_sale_price: p.sale_price ?? 0,
				product_sale_discount: p.sale_disc || 0,
				product_name: p.name || "",
			}));
			setSelectedProds(products);
			if (formProducts.length > 0) {
				form.setFieldsValue({ saleInvoiceProduct: formProducts });
			}
		}
	};

	useEffect(() => {
		if (!conversionContext) return;
		if (!["quotation", "challan", "sale", "saleList"].includes(conversionContext.type))
			return;
		if (isPrefilledFromSource) return;

		const ids =
			Array.isArray(conversionContext.ids) && conversionContext.ids.length
				? conversionContext.ids
				: conversionContext.id
				? [conversionContext.id]
				: [];
		if (!ids.length) return;

		const docTypes =
			Array.isArray(conversionContext.docTypes) &&
			conversionContext.docTypes.length === ids.length
				? conversionContext.docTypes
				: ids.map(() =>
						conversionContext.type === "saleList"
							? "sale"
							: conversionContext.type
				  );

		let isActive = true;

		const endpointFor = (id, type) => {
			if (type === "quotation") return `quotation/${id}`;
			if (type === "challan") return `challan/${id}`;
			return `sale-invoice/${id}`;
		};

		const normalizeInvoice = (data, type) => {
			if (!data) return null;
			if (type === "quotation") {
				const quotation = data.data || data;
				if (quotation.quotationInvoiceProduct) {
					quotation.saleInvoiceProduct = quotation.quotationInvoiceProduct;
				}
				quotation.document_type = "quotation";
				return quotation;
			}
			if (type === "challan") {
				const challan = data.data || data;
				if (challan.challanInvoiceProduct) {
					challan.saleInvoiceProduct = challan.challanInvoiceProduct;
				}
				challan.document_type = "challan";
				return challan;
			}
			const invoice =
				data.singleSaleInvoice ||
				data.data?.singleSaleInvoice ||
				data.data ||
				data;
			if (invoice) invoice.document_type = invoice.document_type || "sale";
			return invoice;
		};

		const fetchSaleDocuments = async () => {
			try {
				const responses = await Promise.all(
					ids.map((id, index) =>
						axios.get(endpointFor(id, docTypes[index] || "sale"))
					)
				);

				const invoices = responses
					.map((res, index) =>
						normalizeInvoice(res?.data, docTypes[index] || "sale")
					)
					.filter(Boolean);

				if (!isActive || !invoices.length) return;

				const productAccumulator = new Map();
				const customerIds = new Set();

				invoices.forEach((invoice) => {
					if (invoice.customer_id != null) customerIds.add(invoice.customer_id);
					const lines = Array.isArray(invoice.saleInvoiceProduct)
						? invoice.saleInvoiceProduct
						: [];
					lines.forEach((item) => {
						if (!item) return;
						const productId = item.product_id || item.product?.id;
						if (!productId) return;

						const productFromStore =
							Array.isArray(allProducts) && allProducts.length
								? allProducts.find((prod) => prod.id === productId)
								: null;
						const productFromRelation = item.product || {};
						const resolvedProduct = productFromStore || productFromRelation || {};

						const currencySymbol =
							resolvedProduct?.product_currency?.symbol ??
							productFromRelation?.product_currency?.symbol ??
							item.product_sale_currency ??
							"₹";
						const currencyConversion =
							resolvedProduct?.product_currency?.conversion ??
							productFromRelation?.product_currency?.conversion ??
							item.product_sale_conversion ??
							1;

						const salePriceSource =
							item.product_sale_price ??
							resolvedProduct?.sale_price ??
							resolvedProduct?.price ??
							0;
						const saleDiscountSource =
							item.product_sale_discount ?? resolvedProduct?.sale_disc ?? 0;
						const qty = Number(item.product_quantity) || 0;

						if (productAccumulator.has(productId)) {
							const existing = productAccumulator.get(productId);
							existing.selectedQty += qty;
						} else {
							productAccumulator.set(productId, {
								...resolvedProduct,
								id: productId,
								selectedQty: qty,
								sale_price: Number(salePriceSource) || 0,
								sale_disc: Number(saleDiscountSource) || 0,
								product_currency: {
									symbol: currencySymbol,
									conversion: Number(currencyConversion) || 1,
									id: resolvedProduct?.product_currency?.id,
								},
								reference_list_price: getReferenceListPriceFromProduct(
									resolvedProduct
								),
							});
						}
					});
				});

				const aggregatedProducts = Array.from(productAccumulator.values()).map(
					(product, index) => ({
						...product,
						key: index,
					})
				);

				const invoiceProductsForForm = aggregatedProducts.map((product) => ({
					product_id: product.id,
					product_quantity: product.selectedQty,
					product_sale_price: product.sale_price,
					product_sale_discount: product.sale_disc || 0,
				}));

				const totalAmount = aggregatedProducts.reduce((sum, product) => {
					const qty = Number(product.selectedQty) || 0;
					const price = Number(product.sale_price) || 0;
					const currencyId = product.product_currency?.id;
					const defaultConversion =
						Number(product.product_currency?.conversion) || 1;
					const conversion = getConversionRate(
						currencyId,
						defaultConversion,
						product.product_currency
					);
					return sum + qty * price * conversion;
				}, 0);

				const totalProductDiscount = aggregatedProducts.reduce((sum, product) => {
					const qty = Number(product.selectedQty) || 0;
					const price = Number(product.sale_price) || 0;
					const currencyId = product.product_currency?.id;
					const defaultConversion =
						Number(product.product_currency?.conversion) || 1;
					const conversion = getConversionRate(
						currencyId,
						defaultConversion,
						product.product_currency
					);
					const discountPct = Number(product.sale_disc) || 0;
					return sum + (qty * price * conversion * discountPct) / 100;
				}, 0);

				if (!isActive) return;

				const sharedCustomerId =
					customerIds.size === 1 ? [...customerIds][0] : undefined;
				const firstInvoice = invoices[0];

				setSelectedProds(aggregatedProducts);
				form.setFieldsValue({
					saleInvoiceProduct: invoiceProductsForForm,
					customer_id: sharedCustomerId,
					sales_person_id:
						sharedCustomerId != null
							? firstInvoice?.user_id
							: undefined,
					paid_amount: 0,
					round_off_enabled: false,
				});

				setCustomer(sharedCustomerId ?? null);
				setSalesPerson(
					sharedCustomerId != null ? firstInvoice?.user_id ?? null : null
				);
				setOrderNum("");
				setOrderDate(null);
				setDate(moment());
				setRoundOffEnabled(false);
				setRoundOffAmount(0);
				setDiscountAmount("");
				setAdditionalDiscount("");
				setDiscountType("item");
				setTotalDiscountPaidDue({
					total: totalAmount,
					productDiscount: totalProductDiscount,
					afterProductDiscount: totalAmount - totalProductDiscount,
					discount: 0,
					afterDiscount: totalAmount - totalProductDiscount,
					paid: 0,
					due: totalAmount - totalProductDiscount,
					totalQty: aggregatedProducts.reduce(
						(sum, product) => sum + (Number(product.selectedQty) || 0),
						0
					),
				});

				setDocumentType("sale");
				setPreInvoiceText(getDocumentDefaults("sale").prefix);
				setIsPrefilledFromSource(true);
			} catch (error) {
				if (isActive) setIsPrefilledFromSource(false);
				console.error(
					"Failed to prepare sale list data for new invoice:",
					error
				);
			}
		};

		fetchSaleDocuments();

		return () => {
			isActive = false;
		};
	}, [
		allProducts,
		conversionContext,
		form,
		isPrefilledFromSource,
	]);

	// Keep legacy single-doc Redux load unused for multi; purchase conversion stays below
	// (removed loadSingleSale-only path for sale/quotation/challan — multi-fetch covers 1+ ids)

	useEffect(() => {
		if (!conversionContext) return;
		if (conversionContext.type !== "purchase") return;
		if (isPrefilledFromSource) return;

		const ids =
			(Array.isArray(conversionContext.ids) && conversionContext.ids.length
				? conversionContext.ids
				: conversionContext.id
					? [conversionContext.id]
					: []);

		if (!ids.length) return;

		let isActive = true;

		const fetchPurchases = async () => {
			try {
				const responses = await Promise.all(
					ids.map((purchaseId) => axios.get(`purchase-invoice/${purchaseId}`))
				);

				const payloads = responses
					.map((res) => {
						if (res?.data?.singlePurchaseInvoice) {
							return res.data;
						}
						if (res?.data?.data?.singlePurchaseInvoice) {
							return res.data.data;
						}
						return res?.data || null;
					})
					.filter(Boolean);

				if (!isActive || !payloads.length) {
					return;
				}

				const productAccumulator = new Map();

				payloads.forEach((purchasePayload) => {
					const invoice = purchasePayload.singlePurchaseInvoice || purchasePayload;
					if (!invoice || !Array.isArray(invoice.purchaseInvoiceProduct)) return;

					invoice.purchaseInvoiceProduct.forEach((item) => {
						if (!item) return;
						const productId = item.product_id || item.product?.id;
						if (!productId) return;

						const productFromStore =
							Array.isArray(allProducts) && allProducts.length
								? allProducts.find((prod) => prod.id === productId)
								: null;
						const productFromRelation = item.product || {};
						const resolvedProduct = productFromStore || productFromRelation || {};

						const currencySymbol =
							resolvedProduct?.product_currency?.symbol ??
							productFromRelation?.product_currency?.symbol ??
							"₹";
						const currencyConversion =
							resolvedProduct?.product_currency?.conversion ??
							productFromRelation?.product_currency?.conversion ??
							1;

						const salePriceSource =
							resolvedProduct?.sale_price ??
							resolvedProduct?.price ??
							item.product_sale_price ??
							item.product_purchase_price ??
							0;

						const saleDiscountSource =
							resolvedProduct?.sale_disc ??
							item.product_sale_discount ??
							0;

						const qty = Number(item.product_quantity) || 0;

						if (productAccumulator.has(productId)) {
							const existing = productAccumulator.get(productId);
							existing.selectedQty += qty;
						} else {
							productAccumulator.set(productId, {
								...resolvedProduct,
								id: productId,
								selectedQty: qty,
								sale_price: Number(
									salePriceSource !== undefined && salePriceSource !== null
										? salePriceSource
										: 0
								),
								sale_disc:
									saleDiscountSource !== undefined && saleDiscountSource !== null
										? Number(saleDiscountSource)
										: 0,
								product_currency: {
									symbol: currencySymbol,
									conversion: Number(currencyConversion) || 1,
								},
								reference_list_price: getReferenceListPriceFromProduct(resolvedProduct),
							});
						}
					});
				});

				const aggregatedProducts = Array.from(productAccumulator.values()).map(
					(product, index) => ({
						...product,
						key: index,
					})
				);

				const invoiceProductsForForm = aggregatedProducts.map((product) => ({
					product_id: product.id,
					product_quantity: product.selectedQty,
					product_sale_price: product.sale_price,
					product_sale_discount: product.sale_disc || 0,
				}));

				const totalAmount = aggregatedProducts.reduce((sum, product) => {
					const qty = Number(product.selectedQty) || 0;
					const price = Number(product.sale_price) || 0;
					const currencyId = product.product_currency?.id;
					const defaultConversion = Number(product.product_currency?.conversion) || 1;
					const conversion = getConversionRate(currencyId, defaultConversion, product.product_currency);
					return sum + qty * price * conversion;
				}, 0);

				const totalProductDiscount = aggregatedProducts.reduce((sum, product) => {
					const qty = Number(product.selectedQty) || 0;
					const price = Number(product.sale_price) || 0;
					const currencyId = product.product_currency?.id;
					const defaultConversion = Number(product.product_currency?.conversion) || 1;
					const conversion = getConversionRate(currencyId, defaultConversion, product.product_currency);
					const discountPct = Number(product.sale_disc) || 0;
					return sum + (qty * price * conversion * discountPct) / 100;
				}, 0);

				if (!isActive) {
					return;
				}

				setSelectedProds(aggregatedProducts);

				form.setFieldsValue({
					saleInvoiceProduct: invoiceProductsForForm,
					customer_id: undefined,
					sales_person_id: undefined,
					paid_amount: 0,
					round_off_enabled: false,
				});

				setCustomer(null);
				setSalesPerson(null);
				setOrderNum("");
				setOrderDate(null);
				setDate(moment());
				setRoundOffEnabled(false);
				setRoundOffAmount(0);
				setDiscountAmount("");
				setAdditionalDiscount("");
				setDiscountType("item");
				setTotalDiscountPaidDue({
					total: totalAmount,
					productDiscount: totalProductDiscount,
					afterProductDiscount: totalAmount - totalProductDiscount,
					discount: 0,
					afterDiscount: totalAmount - totalProductDiscount,
					paid: 0,
					due: totalAmount - totalProductDiscount,
					totalQty: aggregatedProducts.reduce(
						(sum, product) => sum + (Number(product.selectedQty) || 0),
						0
					),
				});

				setDocumentType("sale");
				setPreInvoiceText(getDocumentDefaults("sale").prefix);
				setIsPrefilledFromSource(true);
			} catch (error) {
				if (isActive) {
					setIsPrefilledFromSource(false);
				}
				console.error("Failed to prepare purchase data for sale conversion:", error);
			}
		};

		fetchPurchases();

		return () => {
			isActive = false;
		};
	}, [
		allProducts,
		conversionContext,
		form,
		isPrefilledFromSource,
	]);

	const [customer, setCustomer] = useState(null);
	const [orderNum, setOrderNum] = useState('');
	// const [orderDate,setOrderDate]=useState(moment());	
	const [orderDate, setOrderDate] = useState(null);
	const [salesPerson, setSalesPerson] = useState(null);
	const [salesOrderId, setSalesOrderId] = useState(null);
	const [purchaseOrderId, setPurchaseOrderId] = useState(null);
	const [documentType, setDocumentType] = useState("sale"); // "sale", "quotation", "challan", "sales_order"
	const [documentSettings, setDocumentSettings] = useState(null);

	const getDocumentDefaults = (type) => {
		const settings = documentSettings || {};
		const rowsFor = (t) => {
			if (t === "quotation") return documentSeriesByType.quotation;
			if (t === "challan") return documentSeriesByType.challan;
			return documentSeriesByType.sale;
		};
		const getSeriesDefault = (seriesList, fallbackPrefix) => {
			const rows = Array.isArray(seriesList) ? seriesList : [];
			const def = rows.find((r) => r.is_default) || rows[0] || null;
			if (!def) return { prefix: fallbackPrefix, terms: "", next_number: 1, series_id: null };
			return {
				prefix: def.prefix || fallbackPrefix,
				next_number: def.next_number || 1,
				series_id: def.id,
			};
		};
		if (type === "quotation") {
			const ser = getSeriesDefault(rowsFor("quotation"), DEFAULT_DOCUMENT_PREFIXES.quotation);
			return { prefix: ser.prefix, terms: settings.quotation_terms || "", next_number: ser.next_number, series_id: ser.series_id };
		}
		if (type === "challan") {
			const ser = getSeriesDefault(rowsFor("challan"), DEFAULT_DOCUMENT_PREFIXES.challan);
			return { prefix: ser.prefix, terms: settings.challan_terms || "", next_number: ser.next_number, series_id: ser.series_id };
		}
		if (type === "sales_order") {
			return {
				prefix: DEFAULT_DOCUMENT_PREFIXES.sales_order,
				terms: "",
				next_number: 1,
				series_id: null,
			};
		}
		const ser = getSeriesDefault(rowsFor("sale"), DEFAULT_DOCUMENT_PREFIXES.sale);
		return { prefix: ser.prefix, terms: settings.sale_invoice_terms || "", next_number: ser.next_number, series_id: ser.series_id };
	};

	// Update prefix when document type changes
	useEffect(() => {
		const defaults = getDocumentDefaults(documentType);
		setPreInvoiceText(defaults.prefix || '');
		setInvoiceNum(defaults.next_number || 1);
		setSelectedSeriesId(defaults.series_id || null);
		form.setFieldsValue({ note: defaults.terms });
	}, [documentType, documentSettings, documentSeriesByType, form]);

	const [totalDiscountPaidDue, setTotalDiscountPaidDue] = useState({
		total: 0,
		productDiscount: 0,
		afterProductDiscount: 0,
		discount: 0,
		afterDiscount: 0,
		paid: 0,
		due: 0,
		totalQty: 0
	});

	const getSaleDetail = useSelector((state) => state.users.list); // to get saved invoice details

	useEffect(() => {
		console.log("Initial useEffect - Loading sales data with params:", {
			page: 1,
			limit: 1000,
			startdate: startdate,
			enddate: enddate,
			user: ""
		});

		dispatch(loadAllCustomer({ page: 1, limit: 100 }));
		dispatch(loadProduct({ page: 1, limit: 100 }));
		dispatch(loadAllProductCurrency({ page: 1, limit: 100 }));
		dispatch(loadAllStaff({ status: "true" }));
		getSetting()
			.then((data) => {
				if (data?.result) {
					setDocumentSettings(data.result);
				}
			})
			.catch((error) => {
				console.error("Error loading invoice settings:", error);
			});

		// Load configured number series (default + alternatives)
		Promise.all([
			axios.get(`document-series?document_type=sale_invoice`).catch(() => ({ data: { data: [] } })),
			axios.get(`document-series?document_type=quotation`).catch(() => ({ data: { data: [] } })),
			axios.get(`document-series?document_type=challan`).catch(() => ({ data: { data: [] } })),
		]).then(([saleRes, qRes, cRes]) => {
			setDocumentSeriesByType({
				sale: Array.isArray(saleRes?.data?.data) ? saleRes.data.data : [],
				quotation: Array.isArray(qRes?.data?.data) ? qRes.data.data : [],
				challan: Array.isArray(cRes?.data?.data) ? cRes.data.data : [],
			});
		});
		dispatch(
			loadAllSale({
				page: 1,
				limit: 1000,
				startdate: startdate,
				enddate: enddate,
				user: "",
			})
		);

	}, []);

	// Fetch all invoices (with wide date range) for invoice number calculation
	// This ensures we get the last invoice number regardless of month
	useEffect(() => {
		const fetchAllInvoicesForNumbering = async () => {
			try {
				// Fetch invoices from a very wide date range (10 years back to 1 year ahead)
				const wideStartDate = moment().subtract(10, 'years').format('YYYY-MM-DD');
				const wideEndDate = moment().add(1, 'year').format('YYYY-MM-DD');

				// Fetch all three types of documents in parallel
				const [salesData, quotationsData, challansData] = await Promise.all([
					axios.get(`sale-invoice?&page=1&count=10000&startdate=${wideStartDate}&enddate=${wideEndDate}&user=`).catch((err) => {
						console.error("Error fetching sales for numbering:", err);
						return { data: { allSaleInvoice: [] } };
					}),
					axios.get(`quotation?&page=1&count=10000&startdate=${wideStartDate}&enddate=${wideEndDate}&user=`).catch((err) => {
						console.error("Error fetching quotations for numbering:", err);
						return { data: [] };
					}),
					axios.get(`challan?&page=1&count=10000&startdate=${wideStartDate}&enddate=${wideEndDate}&user=`).catch((err) => {
						console.error("Error fetching challans for numbering:", err);
						return { data: [] };
					})
				]);

				// Add document type to each item
				const sales = salesData.data?.allSaleInvoice ? salesData.data.allSaleInvoice.map(item => ({ ...item, document_type: 'sale' })) : [];
				const quotations = Array.isArray(quotationsData.data) ? quotationsData.data.map(item => ({ ...item, document_type: 'quotation' })) : [];
				const challans = Array.isArray(challansData.data) ? challansData.data.map(item => ({ ...item, document_type: 'challan' })) : [];

				// Combine all documents
				const allDocuments = [...sales, ...quotations, ...challans];
				setAllInvoicesForNumbering(allDocuments);
			} catch (error) {
				console.error("Error fetching all invoices for numbering:", error);
				setAllInvoicesForNumbering([]);
			}
		};

		fetchAllInvoicesForNumbering();
	}, []); // Only fetch once on mount

	// Invoice number preview now comes from selected document series.
	// The backend allocates the final number atomically when saving.

	// setAllSales (useSelector((state) => state.sales.list));

	// let invoiceMax=   Math.max(...allSales.map(o => o.invoice_number))
	// setInvoiceN(invoiceMax)

	// useEffect(() => {
	// }, []);



	// const [invoiceNumbers, setInvoiceNumbers] = useState([]); // to show and set invoice number

	// To get invoice number
	// useEffect(() => {
	// 	dispatch(loadAllSale({ page: 1, limit: 10 }));
	// }, []);




	// useEffect(() => {
	// 	// dispatch(loadAllSale({ page, limit, startdate, enddate, user: user || "" }))
	// }, []);



	const onFormSubmit = async (values) => {
		const formValues =
			values !== undefined && values !== null && typeof values === "object"
				? values
				: form.getFieldsValue();

		// Validate that all new products have a name/title
		const newProductsWithoutName = selectedProds.filter(
			prod => prod.isNewProduct && (!prod.name || !prod.name.trim())
		);

		if (newProductsWithoutName.length > 0) {
			toast.error('Please enter Product Name for all new products before saving the invoice.');
			setLoader(false);
			return;
		}

		const saleInvoiceProduct = selectedProds.map((prod) => {
			// If it's a new product (not in database), include product data
			if (prod.isNewProduct) {
				return {
					isbn: prod.isbn,
					// Include product data for new products
					product_data: {
						isbn: prod.isbn,
						name: prod.name || "",
						author: prod.author || "",
						sale_price: prod.sale_price || 0,
						purchase_price: prod.purchase_price || 0,
						quantity: prod.quantity || 0,
						product_currency_id: prod.product_currency?.id || allCurrencies?.[0]?.id || null,
						book_publisher_id: prod.book_publisher?.id || null,
						product_category_id: prod.product_category?.id || null,
						unit_measurement: prod.unit_measurement || 0,
						unit_type: prod.unit_type || "",
					},
					product_quantity: prod.selectedQty,
					product_sale_price: prod.sale_price,
					product_sale_discount: prod.sale_disc || 0,
					product_sale_currency: prod.product_currency?.symbol || allCurrencies?.[0]?.symbol || "",
					product_sale_conversion: getConversionRate(
						prod.product_currency?.id || allCurrencies?.[0]?.id,
						prod.product_currency?.conversion || allCurrencies?.[0]?.conversion || 1,
						prod.product_currency || allCurrencies?.[0]
					),
				};
			} else {
				// Existing product - use product_id
				return {
					product_id: prod.id,
					product_quantity: prod.selectedQty,
					product_sale_price: prod.sale_price,
					product_sale_discount: prod.sale_disc || 0,
					product_sale_currency: prod.product_currency?.symbol || "₹",
					product_sale_conversion: getConversionRate(
						prod.product_currency?.id,
						prod.product_currency?.conversion || 1,
						prod.product_currency
					),
				};
			}
		});

		try {
			const valueData = {
				orderNumber: orderNum,
				orderDate: orderDate ? orderDate.format("YYYY-MM-DD") : null,
				date: date,
				paid_amount: totalDiscountPaidDue.paid,
				discount: totalDiscountPaidDue.discount,
				round_off_enabled: roundOffEnabled,
				round_off_amount: roundOffAmount,
				customer_id: customer,
				user_id: salesPerson,
				sales_order_id: salesOrderId || null,
				saleInvoiceProduct,
				document_series_id: selectedSeriesId,
				prefix: preInvoiceText,
				invoiceNumber: invoiceNum
			};

			// console.log("InvoiceData", valueData)
			let resp;

			// Call appropriate API based on document type
			if (documentType === "quotation") {
				// Import and call quotation API
				const response = await fetch(`${process.env.REACT_APP_API}quotation`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${localStorage.getItem('access-token')}`
					},
					body: JSON.stringify(valueData)
				});
				const data = await response.json();
				resp = { message: "success", createdInvoiceId: data.createdQuotation.id };
			} else if (documentType === "challan") {
				// Import and call challan API
				const response = await fetch(`${process.env.REACT_APP_API}challan`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${localStorage.getItem('access-token')}`
					},
					body: JSON.stringify(valueData)
				});
				const data = await response.json();
				resp = { message: "success", createdInvoiceId: data.createdChallan.id };
			} else if (documentType === "sales_order") {
				// Build sales order payload from selectedProds
				const orderItems = selectedProds.map((prod) => {
					if (prod.isNewProduct) {
						return {
							isbn: prod.isbn,
							name: prod.name || "",
							author: prod.author || "",
							book_publisher_id: prod.book_publisher?.id || null,
							ordered_quantity: prod.selectedQty || 1,
							sale_price: prod.sale_price || 0,
							discount: prod.sale_disc || 0,
						};
					} else {
						return {
							product_id: prod.id,
							ordered_quantity: prod.selectedQty || 1,
							sale_price: prod.sale_price || 0,
							discount: prod.sale_disc || 0,
						};
					}
				});

				const salesOrderData = {
					order_number: `${preInvoiceText}${invoiceNum}`,
					order_date: orderDate ? orderDate.format("YYYY-MM-DD") : (date ? moment(date).format("YYYY-MM-DD") : null),
					customer_id: customer,
					user_id: salesPerson,
					discount: totalDiscountPaidDue.discount || 0,
					note: formValues.note || "",
					order_items: orderItems,
				};

				// Dispatch createSalesOrder action
				resp = await dispatch(createSalesOrder(salesOrderData));
			} else {
				// Default to sale
				resp = await dispatch(addSale(valueData));
			}

			if (resp.message === "success") {
				form.resetFields();
				setFormData({});
				setAfterDiscount(0);
				setDiscountAmount("");
				setAdditionalDiscount("");
				setDiscountType("item");
				setRoundOffEnabled(false);
				setRoundOffAmount(0);
				setTotalDiscountPaidDue({
					total: 0,
					productDiscount: 0,
					afterProductDiscount: 0,
					discount: 0,
					afterDiscount: 0,
					paid: 0,
					due: 0,
					totalQty: 0,
				});
				setLoader(false);
				dispatch(
					loadAllSale({
						page: 1,
						limit: "",
						startdate: moment().format("YYYY-MM-DD"),
						enddate: moment().format("YYYY-MM-DD"),
						user: "",
					})
				);
				// Navigate based on document type
				if (documentType === "quotation") {
					// For quotations, we might need a separate view or use the sale detail view
					toast.success("Quotation created successfully");
					navigate(`/sale`);
				} else if (documentType === "challan") {
					toast.success("Challan created successfully");
					navigate(`/sale`);
				} else if (documentType === "sales_order") {
					toast.success("Sales Order created successfully");
					const orderId = resp?.orderId || resp?.order?.id;
					if (orderId) {
						navigate(`/sales-order/${orderId}`);
					} else {
						navigate(`/sales-order`);
					}
				} else {
					navigate(`/sale/${resp.createdInvoiceId}`);
				}
			} else {
				setLoader(false);
			}
		} catch (error) {
			console.log(error.message);
			setLoader(false);
			toast.error("Error while sales");
		}
	};

	const updateFormData = () => {
		// Use selectedProds instead of form data for calculations
		const total = selectedProds?.reduce((acc, p) => {
			const product_quantity = p.selectedQty || 0;
			const product_sale_price = p.sale_price || 0;
			const product_sale_conversion = p.product_currency?.conversion || 1;
			const product_sale_discount = p.sale_disc || 0;

			acc += product_quantity * product_sale_price * product_sale_conversion;
			return acc;
		}, 0);

		const productDiscount = selectedProds?.reduce((acc, p) => {
			const product_sale_discount = p.sale_disc || 0;
			const product_quantity = p.selectedQty || 0;
			const product_sale_price = p.sale_price || 0;
			const product_sale_conversion = p.product_currency?.conversion || 1;

			console.log("product_sale_discount", product_sale_discount);
			acc += (product_sale_discount / 100) * product_quantity * product_sale_price * product_sale_conversion;
			return acc;
		}, 0);

		// Get current form data and update with calculated values
		const data = form.getFieldsValue();
		data.total = total;
		data.productDiscount = productDiscount;
		console.log("data.total", data.total)
		console.log("data.productDiscount", data.productDiscount)
		// data.due = total - (data.paid_amount ?? 0) - (data.discount ?? 0);
		data.due = total - (data.paid_amount ?? 0) - (data.discount ?? 0) - (data.productDiscount ?? 0);

		setFormData(data);
		if (data.discount) {
			setAfterDiscount(total - (data.discount ?? 0));
		}
		if (data.discount == 0) {
			setAfterDiscount(0);
		}
		if (data.productDiscount) {
			setAfterProductDiscount(total - (data.productDiscount ?? 0));
		}
		if (data.productDiscount == 0) {
			setAfterProductDiscount(0);
		}
	};

	// Select Supplier Function
	const onChange = async (values) => {
		updateFormData();
	};

	const onSearch = (value) => { };

	// Products Handlers

	// Prevent form submission on Enter
	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault(); // Prevent form submission on Enter key press
		}
	};

	const handleSelectedProds = (prodId, key) => {
		// First try to find in global search results, then fallback to allProducts
		let foundProd = globalSearchResults?.find((item) => item.id === prodId);

		if (!foundProd) {
			foundProd = allProducts?.find((item) => item.id === prodId);
		}

		if (!foundProd) return; // Exit if product not found

		setSelectedProds((prev) => {
			// Check if this product already exists in the list (by product id)
			const existingProductIndex = prev.findIndex(prod => prod.id === prodId);

			if (existingProductIndex !== -1) {
				// Product already exists - increase quantity by 1
				const updated = [...prev];
				updated[existingProductIndex] = {
					...updated[existingProductIndex],
					selectedQty: (updated[existingProductIndex].selectedQty || 1) + 1
				};
				toast.info(`Quantity increased for "${foundProd.name}"`);
				return updated;
			} else {
				// New product - add to the beginning of the array (reversed order)
				const productWithDiscount = {
					...foundProd,
					selectedQty: 1,
					sale_disc: discount,
					key: key, // Add key to track the form field
					isNewProduct: false, // Existing product from database
					reference_list_price: getReferenceListPriceFromProduct(foundProd),
				};
				return [productWithDiscount, ...prev]; // Add at beginning
			}
		});
	};

	/** Bulk-add books from multi-select checkboxes into the invoice lines (prefilled, editable). */
	const handleSelectedProdsBulk = (products = []) => {
		if (!Array.isArray(products) || products.length === 0) return;

		const baseTimestamp = Date.now();
		setSelectedProds((prev) => {
			const existingIds = new Set(prev.map((p) => p.id).filter(Boolean));
			const next = [...prev];
			let added = 0;
			let skipped = 0;

			products.forEach((product, index) => {
				if (!product?.id) return;
				if (existingIds.has(product.id)) {
					skipped += 1;
					return;
				}
				existingIds.add(product.id);
				next.push({
					...product,
					selectedQty: 1,
					sale_price: product.sale_price ?? 0,
					sale_disc: discount || 0,
					key: baseTimestamp + index + product.id * 1000,
					isNewProduct: false,
					reference_list_price: getReferenceListPriceFromProduct(product),
				});
				added += 1;
			});

			if (added > 0) {
				toast.success(
					`${added} book${added > 1 ? "s" : ""} added to invoice${
						skipped ? ` (${skipped} already on invoice)` : ""
					}`
				);
			} else if (skipped > 0) {
				toast.info("Selected books are already on this invoice");
			}

			return next;
		});
	};

	// Handler for adding a new product by ISBN (when ISBN doesn't exist in database)
	const handleAddNewProductByISBN = (isbn, key) => {
		if (!isbn || !isbn.trim()) return;

		setSelectedProds((prev) => {
			// Check if this ISBN already exists in the list
			const existingProductIndex = prev.findIndex(prod => prod.isbn === isbn.trim() && prod.isNewProduct);

			if (existingProductIndex !== -1) {
				// Product already exists - increase quantity by 1
				const updated = [...prev];
				updated[existingProductIndex] = {
					...updated[existingProductIndex],
					selectedQty: (updated[existingProductIndex].selectedQty || 1) + 1
				};
				toast.info(`Quantity increased for ISBN "${isbn}"`);
				return updated;
			} else {
				// Create new product object for manual entry
				const newProduct = {
					isbn: isbn.trim(),
					name: "",
					author: "",
					sale_price: 0,
					selectedQty: 1,
					sale_disc: discount,
					key: key,
					isNewProduct: true, // Flag to indicate this is a new product
					product_currency: allCurrencies?.[0] || null, // Default to first currency
					book_publisher: null,
					product_category: null,
					unit_measurement: 0,
					unit_type: "",
					purchase_price: 0,
					quantity: 0
				};
				return [newProduct, ...prev];
			}
		});
	};

	// Handler for updating new product fields
	const handleUpdateNewProductField = (key, field, value) => {
		setSelectedProds((prev) =>
			prev.map((prod) =>
				prod.key === key ? { ...prod, [field]: value } : prod
			)
		);
	};

	const handleSelectedProdsQty = (key, qty) => {
		setSelectedProds((prev) =>
			prev.map((prod) =>
				prod.key === key ? { ...prod, selectedQty: qty } : prod
			)
		);
	};

	const handleSelectedProdsSalePrice = (key, salePrice) => {
		setSelectedProds((prev) =>
			prev.map((prod) =>
				prod.key === key ? { ...prod, sale_price: salePrice } : prod
			)
		);
	};

	const handleSelectedProdsSaleDisc = (key, saleDisc) => {
		setSelectedProds((prev) =>
			prev.map((prod) =>
				prod.key === key ? { ...prod, sale_disc: saleDisc } : prod
			)
		);
		console.log("selectedProduct", selectedProds);
	};

	const applyFlatDiscountToAll = (value) => {
		setGlobalDiscountValue(value);
		const normalizedValue =
			value === "" || value === null || Number.isNaN(Number(value))
				? 0
				: Number(value);

		if (normalizedValue < 0 || normalizedValue > 100) {
			return;
		}

		setSelectedProds((prev) =>
			prev.map((prod) => ({
				...prod,
				sale_disc: normalizedValue,
			}))
		);
	};

	const applyQuantityToAll = (value) => {
		setGlobalQuantityValue(value);
		const normalizedValue =
			value === "" || value === null || Number.isNaN(Number(value))
				? ""
				: Number(value);

		if (normalizedValue === "" || normalizedValue < 0) {
			return;
		}

		setSelectedProds((prev) =>
			prev.map((prod) => ({
				...prod,
				selectedQty: normalizedValue,
			}))
		);
	};

	const handleSelectedProdsCurrency = (key, currencyId) => {
		const selectedCurrency = allCurrencies?.find(c => c.id === currencyId);

		if (selectedCurrency) {
			setSelectedProds((prev) =>
				prev.map((prod) =>
					prod.key === key ? { ...prod, product_currency: selectedCurrency } : prod
				)
			);
		}
	};

	const handleDeleteProd = (key) => {
		setSelectedProds((prev) => prev.filter((prod) => prod.key !== key));
	};

	// Calculate total product discount
	const calculateTotalProductDiscount = () => {
		return selectedProds.reduce((sum, prod) => {
			const itemTotal = (prod.sale_price || 0) * (prod.selectedQty || 0) * (prod.product_currency?.conversion || 1);
			const itemDiscount = (itemTotal * (prod.sale_disc || 0)) / 100;
			return sum + itemDiscount;
		}, 0);
	};

	const handleDiscount = (discountAmount) => {
		const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
		const afterAdditionalDiscount = subtotalAfterProductDiscounts - discountAmount;
		const finalTotal = afterAdditionalDiscount + (roundOffEnabled ? roundOffAmount : 0);
		let dueAmount = finalTotal;
		if (totalDiscountPaidDue.paid > 0) {
			dueAmount = dueAmount - totalDiscountPaidDue.paid;
		}
		setTotalDiscountPaidDue((prev) => ({
			...prev,
			discount: discountAmount,
			due: dueAmount,
			afterDiscount: finalTotal, // Include round off in afterDiscount
		}));
		setDiscountAmount(discountAmount);
		if (discountAmount === "" || discountAmount === 0) {
			setAdditionalDiscount("");
		} else if (subtotalAfterProductDiscounts > 0) {
			const discountPercent = (discountAmount / subtotalAfterProductDiscounts) * 100;
			setAdditionalDiscount(discountPercent.toFixed(2));
		}
	};

	const handlePercentageDiscount = (discountPercent) => {
		let additionalDiscountAmount = 0;
		if (discountPercent > 0) {
			const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
			additionalDiscountAmount = Math.round((subtotalAfterProductDiscounts * discountPercent) / 100 * 100) / 100;
		}
		setAdditionalDiscount(discountPercent);
		handleDiscount(additionalDiscountAmount);
	};

	const handleRoundOff = (enabled, amount = null) => {
		setRoundOffEnabled(enabled);
		if (enabled) {
			// If amount is not provided, calculate automatic round off
			let roundOffValue = amount;
			if (amount === null) {
				const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
				const afterAdditionalDiscount = subtotalAfterProductDiscounts - totalDiscountPaidDue.discount;
				const roundedTotal = Math.round(afterAdditionalDiscount);
				roundOffValue = roundedTotal - afterAdditionalDiscount;
				// Round to 2 decimal places
				roundOffValue = Math.round(roundOffValue * 100) / 100;
			}

			setRoundOffAmount(roundOffValue);
			// Recalculate totals with round off
			const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
			const afterAdditionalDiscount = subtotalAfterProductDiscounts - totalDiscountPaidDue.discount;
			const finalTotal = afterAdditionalDiscount + roundOffValue;
			let dueAmount = finalTotal - totalDiscountPaidDue.paid;

			setTotalDiscountPaidDue((prev) => ({
				...prev,
				afterDiscount: finalTotal,
				due: dueAmount,
			}));
		} else {
			setRoundOffAmount(0);
			// Recalculate totals without round off
			const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
			const afterAdditionalDiscount = subtotalAfterProductDiscounts - totalDiscountPaidDue.discount;
			let dueAmount = afterAdditionalDiscount - totalDiscountPaidDue.paid;

			setTotalDiscountPaidDue((prev) => ({
				...prev,
				afterDiscount: afterAdditionalDiscount,
				due: dueAmount,
			}));
		}
	};

	const handlePaid = (paidAmount) => {
		// Calculate the final total including round off
		const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
		const afterAdditionalDiscount = subtotalAfterProductDiscounts - totalDiscountPaidDue.discount;
		const finalTotal = afterAdditionalDiscount + (roundOffEnabled ? roundOffAmount : 0);
		const dueAmount = finalTotal - paidAmount;

		setTotalDiscountPaidDue((prev) => ({
			...prev,
			paid: paidAmount,
			due: dueAmount,
			afterDiscount: finalTotal, // Update afterDiscount to include round off
		}));
	};

	const handleSaveInvoiceConfirm = async () => {
		try {
			await form.validateFields();
		} catch {
			return;
		}
		const formValues = form.getFieldsValue();

		const proceedSave = async () => {
			onClickLoading();
			try {
				await onFormSubmit(formValues);
			} catch (e) {
				setLoader(false);
			}
		};

		if (documentType !== "sale") {
			await proceedSave();
			return;
		}

		await confirmMasterListPriceSyncThen(selectedProds, proceedSave, {
			cancelText: "No, save invoice only",
		});
	};

	useEffect(() => {
		if (selectedProds.length > 0) {
			let total = 0;
			let afterDiscount = 0;
			let due = 0;
			let productDiscount = 0;
			let afterProductDiscount = 0;
			let totalQty = 0;

			selectedProds.forEach((prod) => {
				const currencyId = prod.product_currency?.id;
				const defaultConversion = prod.product_currency?.conversion || 1;
				const conversion = getConversionRate(currencyId, defaultConversion, prod.product_currency);
				total += prod.sale_price * prod.selectedQty * conversion; // to calculate product wise total 
				productDiscount += prod.sale_price * prod.selectedQty * conversion * (prod.sale_disc / 100); // To calculate discount product wise 
				afterProductDiscount = total - productDiscount;
				totalQty += prod.selectedQty;
			});

			if (totalDiscountPaidDue.discount > 0) {
				afterDiscount = afterProductDiscount - totalDiscountPaidDue.discount;
			} else afterDiscount = afterProductDiscount;

			// Add round off to final total
			const finalTotal = afterDiscount + (roundOffEnabled ? roundOffAmount : 0);

			if (totalDiscountPaidDue.paid > 0) {
				due = finalTotal - totalDiscountPaidDue.paid;
			} else due = finalTotal;

			setTotalDiscountPaidDue((prev) => ({
				...prev,
				total,
				afterDiscount: finalTotal, // Use finalTotal which includes round off
				due,
				afterProductDiscount,
				productDiscount,
				totalQty
			}));
		}
	}, [selectedProds, totalDiscountPaidDue.paid, totalDiscountPaidDue.discount, roundOffEnabled, roundOffAmount, currencyConversions]);

	const handleDiscountTypeChange = (value) => {
		setDiscountType(value);
		if (value === "item") {
			setTotalDiscountPaidDue((prev) => ({ ...prev, discount: 0 }));
			setDiscountAmount("");
			setAdditionalDiscount("");
			form.setFieldsValue({ billDiscount: undefined });
			setDiscount(0);
		}
	};

	const handleBillDataExtracted = async (data) => {
		console.log('Extracted data received:', data);
		setExtractedData(data);
		setShowBillUpload(false);

		try {
			// Auto-populate form with extracted data
			if (data.existingCustomer) {
				setCustomer(data.existingCustomer.id);
				form.setFieldsValue({ customer_id: data.existingCustomer.id });
			} else if (data.newCustomers && data.newCustomers.length > 0) {
				toast.warning('Please add the customer first before using the data.');
				return;
			} else {
				toast.warning('No customer information found in the extracted data.');
			}

			// Set invoice date
			if (data.invoiceDate) {
				const invoiceDate = moment(data.invoiceDate, 'YYYY-MM-DD');
				setDate(invoiceDate);
				form.setFieldsValue({ date: invoiceDate });
			}

			// Process products - existing and new
			let processedProducts = [];

			// Add existing products
			if (data.existingProducts && data.existingProducts.length > 0) {
				processedProducts = data.existingProducts
					.map((product, idx) => {
						const foundProduct = allProducts.find(p => p.id === product.id);
						if (!foundProduct) return null;
						return {
							...foundProduct,
							selectedQty: product.quantity || product.extractedQuantity || 1,
							sale_price: product.price || product.extractedPrice || foundProduct.sale_price || 0,
							sale_disc: product.discount || product.extractedDiscount || 0,
							key: product.key ?? idx,
							reference_list_price: getReferenceListPriceFromProduct(foundProduct),
						};
					})
					.filter(Boolean);
			}

			// Add new products (they should have been created, so find them by ISBN)
			if (data.newProducts && data.newProducts.length > 0) {
				// Reload products to get newly created ones
				await dispatch(loadProduct({ page: 1, limit: 10000 }));

				// Wait a bit for the state to update
				setTimeout(() => {
								data.newProducts.forEach((newProduct, npIdx) => {
						if (newProduct.isbn) {
							const foundProduct = allProducts.find(p => p.isbn === newProduct.isbn);
							if (foundProduct) {
								processedProducts.push({
									...foundProduct,
									selectedQty: newProduct.quantity || 1,
									sale_price: newProduct.price || foundProduct.sale_price || 0,
									sale_disc: newProduct.discount || 0,
									key: processedProducts.length,
									reference_list_price: getReferenceListPriceFromProduct(foundProduct),
								});
							} else {
								// If product not found, create it as a new product entry
								processedProducts.push({
									isbn: newProduct.isbn,
									name: newProduct.title || newProduct.name || '',
									author: newProduct.author || '',
									sale_price: newProduct.price || 0,
									selectedQty: newProduct.quantity || 1,
									sale_disc: newProduct.discount || 0,
									isNewProduct: true,
									product_currency: allCurrencies?.[0] || null,
									book_publisher: newProduct.publisher ? { name: newProduct.publisher } : null,
									key: processedProducts.length
								});
							}
						} else {
							// Product without ISBN - add as new product
							processedProducts.push({
								name: newProduct.title || newProduct.name || '',
								author: newProduct.author || '',
								sale_price: newProduct.price || 0,
								selectedQty: newProduct.quantity || 1,
								sale_disc: newProduct.discount || 0,
								isNewProduct: true,
								product_currency: allCurrencies?.[0] || null,
								book_publisher: newProduct.publisher ? { name: newProduct.publisher } : null,
								key: processedProducts.length
							});
						}
								});

					// Ensure stable unique keys for all processed products
					processedProducts = processedProducts.map((p, i) => ({
						...p,
						key: p.key != null ? p.key : i,
					}));

					setSelectedProds(processedProducts);

					// Set form fields so Form.List displays the products
					// Use setTimeout to ensure form is ready and Form.List can initialize
					setTimeout(() => {
						const formProducts = processedProducts.map((prod, idx) => ({
							product_id: prod.id || null,
							product_quantity: prod.selectedQty || 1,
							product_sale_price: prod.sale_price || 0,
							product_sale_discount: prod.sale_disc || 0,
							product_name: prod.name || '',
						}));

						// Get current form values to preserve other fields
						const currentValues = form.getFieldsValue();

						form.setFieldsValue({
							...currentValues,
							saleInvoiceProduct: formProducts
						});
					}, 100);

					toast.success('Products loaded from invoice analysis!');
				}, 500);
			} else {
				setSelectedProds(processedProducts);

				// Set form fields so Form.List displays the products
				// Use setTimeout to ensure form is ready and Form.List can initialize
				setTimeout(() => {
					const formProducts = processedProducts.map((prod, idx) => ({
						product_id: prod.id || null,
						product_quantity: prod.selectedQty || 1,
						product_sale_price: prod.sale_price || 0,
						product_sale_discount: prod.sale_disc || 0,
						product_name: prod.name || '',
					}));

					// Get current form values to preserve other fields
					const currentValues = form.getFieldsValue();

					form.setFieldsValue({
						...currentValues,
						saleInvoiceProduct: formProducts
					});
				}, 100);

				toast.success('Products loaded from invoice analysis!');
			}
		} catch (error) {
			console.error('Error processing extracted data:', error);
			toast.error('Error processing extracted data');
		}
	};
	return (
		<Card>
			<Form
				form={form}
				className='m-lg-4'
				name='dynamic_form_nest_item'
				// onFinish={onFinish}
				onKeyDown={handleKeyDown}
				onChange={onChange}
				onFinishFailed={() => {
					setLoader(false);
				}}
				layout='vertical'
				size='small'
				autoComplete='off'
				style={{ fontSize: '13px' }}>
				<Row  gutter={[16, 16]}>
					<Col span={24}>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
							<Title level={4} >
								Create New Invoice
							</Title>
							<Button
								type="primary"
								icon={<RobotOutlined />}
								onClick={() => setShowBillUpload(true)}
								style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
							>
								AI Invoice Upload
							</Button>
						</div>
					</Col>

					{/* Available Currencies Section - Compact */}
					<Col span={24}>
						<Card
							size="small"
							title={
								<span>
									<DollarOutlined style={{ marginRight: '8px' }} />
									Available Currencies
								</span>
							}
							style={{ marginBottom: '16px' }}
							bodyStyle={{ padding: '8px 12px' }}
						>
							{allCurrencies && allCurrencies.length > 0 ? (
								<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
									{allCurrencies.map((currency) => {
										const localConversion = currencyConversions[currency.id];
										const displayConversion = localConversion !== undefined ? localConversion : (currency.conversion || 1);
										return (
											<div
												key={currency.id}
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: '6px',
													padding: '4px 8px',
													border: '1px solid #d9d9d9',
													borderRadius: '4px',
													backgroundColor: '#fafafa',
													fontSize: '13px'
												}}
											>
												<Tag color="blue" style={{ margin: 0, fontSize: '12px' }}>
													{currency.symbol}
												</Tag>
												<span style={{ fontWeight: '500' }}>{displayConversion}</span>
												<EditOutlined
													style={{
														cursor: 'pointer',
														color: '#1890ff',
														fontSize: '12px'
													}}
													onClick={() => handleEditCurrency(currency)}
												/>
											</div>
										);
									})}
								</div>
							) : (
								<div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
									No currencies available
								</div>
							)}
						</Card>
					</Col>

					{/* Main Fields Row - Mobile Responsive */}
					<Col span={24}>
						<Row gutter={[16, 16]}>
							{/* Document Type */}
							<Col xs={24} sm={12} md={6} lg={3} xl={3}>
								<Form.Item label='Document Type'>
									<Select
										value={documentType}
										onChange={setDocumentType}
										style={{ width: "100%", fontSize: '13px' }}
									>
										<Option value="sale">Sale</Option>
										<Option value="quotation">Quotation</Option>
										<Option value="challan">Challan</Option>
										<Option value="sales_order">Sales Order</Option>
									</Select>
								</Form.Item>
							</Col>

							{/* Order Date */}
							<Col xs={24} sm={12} md={6} lg={3} xl={3}>
								<Form.Item label='Order Date'>
									<DatePicker
										onChange={(value) => setOrderDate(value)}
										defaultValue={orderDate}
										style={{ width: "100%", fontSize: '13px' }}
										format="DD-MMM-YYYY"
										placeholder="Order Date"
									/>
								</Form.Item>
							</Col>

							{/* Order Number */}
							<Col xs={24} sm={12} md={6} lg={3} xl={3}>
								<Form.Item label='Order No.'>
									<Input
										onChange={(e) => setOrderNum(e.target.value)}
										defaultValue={orderNum}
										style={{ width: "100%", fontSize: '13px' }}
										placeholder="Order Number"
									/>
								</Form.Item>
							</Col>

							{/* Customer */}
							<Col xs={24} sm={24} md={12} lg={6} xl={4}>
								<Form.Item
									label='Customer'
									name='customer_id'
									rules={[
										{
											required: true,
											message: "Please Select a Customer!",
										},
									]}>
									<Select
										loading={!allCustomer}
										showSearch
										placeholder='Select Customer'
										optionFilterProp='children'
										onChange={(id) => {
											if (id === '__add_customer__') {
												form.setFieldsValue({ customer_id: undefined });
												setCustomer(null);
												setAddCustomerModalVisible(true);
												return;
											}
											setCustomer(id);
											setCustomerSearchValue('');
										}}
										onSearch={(value) => setCustomerSearchValue(value || '')}
										filterOption={(input, option) =>
											option?.value === '__add_customer__' ? true : option?.children?.toLowerCase().includes(input?.toLowerCase())
										}
										style={{ fontSize: '13px', width: '100%' }}
										dropdownStyle={{ fontSize: '13px' }}
									>
										{allCustomer &&
											allCustomer.map((sup) => (
												<Option key={sup.id} value={sup.id}>
													{sup.name}
												</Option>
											))}
										<Option value="__add_customer__" style={{ color: '#1890ff', fontWeight: 600, borderTop: '1px solid #f0f0f0' }}>
											<PlusOutlined /> Add New Customer{customerSearchValue?.trim() ? `: "${customerSearchValue.trim()}"` : ''}
										</Option>
									</Select>
								</Form.Item>
							</Col>

							{/* Invoice / Order Date */}
							<Col xs={24} sm={12} md={6} lg={3} xl={3}>
								<Form.Item label={
									documentType === 'quotation' ? 'Quotation Date' :
										documentType === 'challan' ? 'Challan Date' :
											documentType === 'sales_order' ? 'Order Date' :
												'Invoice Date'
								} required>
									<DatePicker
										onChange={(value) => setDate(value._d)}
										defaultValue={date}
										style={{ width: "100%", fontSize: '13px' }}
										format="DD-MMM-YYYY"
										placeholder={
											documentType === 'quotation' ? 'Quotation Date' :
												documentType === 'challan' ? 'Challan Date' :
													documentType === 'sales_order' ? 'Order Date' :
														'Invoice Date'
										}
									/>
								</Form.Item>
							</Col>

							{/* Invoice Number */}
							<Col xs={24} sm={12} md={7} lg={4} xl={4}>
								<Form.Item label={
									documentType === 'quotation' ? 'Quotation Number' :
										documentType === 'challan' ? 'Challan Number' :
											'Invoice Number'
								} required>
									<div style={{
										display: 'flex',
										alignItems: 'center',
										border: '1px solid #d9d9d9',
										borderRadius: '6px',
										backgroundColor: '#fff',
										minHeight: '32px',
										padding: '0 8px',
										transition: 'all 0.3s',
										overflow: 'hidden',
										width: '100%',
									}}
										onMouseEnter={(e) => {
											e.currentTarget.style.borderColor = '#40a9ff';
										}}
										onMouseLeave={(e) => {
											e.currentTarget.style.borderColor = '#d9d9d9';
										}}>
										{/* Single combined field: series + next number */}
										<Select
											size="small"
											bordered={false}
											value={selectedSeriesId}
											onChange={(id) => {
												const list =
													documentType === "quotation"
														? documentSeriesByType.quotation
														: documentType === "challan"
															? documentSeriesByType.challan
															: documentSeriesByType.sale;
												const found = (list || []).find((r) => r.id === id);
												setSelectedSeriesId(id);
												if (found) {
													setPreInvoiceText(found.prefix || '');
													setInvoiceNum(found.next_number || 1);
												}
											}}
											style={{ flex: "1 1 auto", minWidth: 110 }}
											dropdownMatchSelectWidth={false}
											options={(() => {
												const list =
													documentType === "quotation"
														? documentSeriesByType.quotation
														: documentType === "challan"
															? documentSeriesByType.challan
															: documentSeriesByType.sale;
												return (list || []).map((r) => ({
													value: r.id,
													label: `${r.prefix || ''}`,
												}));
											})()}
										/>
										<div style={{ display: "flex", alignItems: "center", flex: "0 0 72px", marginLeft: 6 }}>
											<InputNumber
												controls={false}
												min={1}
												value={invoiceNum}
												onChange={(v) => setInvoiceNum(v == null ? 1 : Number(v))}
												style={{
													border: 'none',
													boxShadow: 'none',
													width: "100%",
													minWidth: 72,
												}}
											/>
										</div>
									</div>
								</Form.Item>
							</Col>

							{/* Sales Person */}
							<Col xs={24} sm={12} md={6} lg={3} xl={3}>
								<Form.Item
									label='Sales Person'
									name='sales_person_id'
									rules={[
										{
											required: true,
											message: "Please Select a sales person!",
										},
									]}>
									<Select
										loading={!allStaff}
										showSearch
										placeholder='Select Sales Person'
										optionFilterProp='children'
										onChange={(id) => setSalesPerson(id)}
										onSearch={onSearch}
										filterOption={(input, option) =>
											option.children.toLowerCase().includes(input.toLowerCase())
										}
										style={{ fontSize: '13px', width: '100%' }}
										dropdownStyle={{ fontSize: '13px' }}
									>
										{allStaff &&
											allStaff?.map((info) => (
												<Option key={info.id} value={info.id}>
													{info.username}
												</Option>
											))}
									</Select>
								</Form.Item>
							</Col>

							{/* Set Discount */}
							<Col xs={24} sm={24} md={12} lg={6} xl={4}>
								<Form.Item label="Set Discount">
									<Radio.Group
										value={discountType}
										onChange={(e) => handleDiscountTypeChange(e.target.value)}
									>
										<Radio value="bill">Bill Discount</Radio>
										<Radio value="item">Item Wise Discount</Radio>
									</Radio.Group>
									{discountType === "bill" && (
										<div style={{ marginTop: '8px' }}>
											<Form.Item
												name="billDiscount"
												rules={[
													{
														required: true,
														message: "Please input bill discount!",
													},
													{
														validator: (_, value) => {
															const floatValue = parseFloat(value);
															if (
																isNaN(floatValue) ||
																floatValue < 0 ||
																floatValue > 100
															) {
																return Promise.reject(
																	"Discount must be a number between 0 and 100"
																);
															}
															const decimalPlaces = floatValue
																.toString()
																.split(".")[1];
															if (decimalPlaces && decimalPlaces.length > 2) {
																return Promise.reject(
																	"Discount can have maximum 2 decimal places"
																);
															}
															return Promise.resolve();
														},
													},
												]}
											>
												<div style={{ display: "flex", alignItems: "center" }}>
													<InputNumber
														placeholder="Enter bill discount"
														style={{ width: "85%" }}
														onChange={(value) => setDiscount(value)}
														disabled={discountType !== "bill"}
													/>
													<h3 style={{ margin: "0 0 0 10px" }}>%</h3>
												</div>
											</Form.Item>
										</div>
									)}
								</Form.Item>
							</Col>

							{/* Global Discount & Quantity */}
							<Col xs={24} sm={24} md={12} lg={6} xl={4}>
								<Form.Item label="Apply To All Items">
									<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
										<InputNumber
											placeholder="Flat discount %"
											min={0}
											max={100}
											value={globalDiscountValue}
											onChange={applyFlatDiscountToAll}
											style={{ width: "100%" }}
										/>
										<InputNumber
											placeholder="Set quantity"
											min={0}
											value={globalQuantityValue}
											onChange={applyQuantityToAll}
											style={{ width: "100%" }}
										/>
									</div>
								</Form.Item>
							</Col>
						</Row>
					</Col>

					<Col span={24} lg={24}>
						<Products
							formData={formData}
							setData={setFormData}
							allProducts={allProducts}
							// updateFormData={updateFormData}
							selectedProds={selectedProds}
							handleSelectedProds={handleSelectedProds}
							handleSelectedProdsBulk={handleSelectedProdsBulk}
							handleSelectedProdsQty={handleSelectedProdsQty}
							handleSelectedProdsSalePrice={handleSelectedProdsSalePrice}
							handleDeleteProd={handleDeleteProd}
							handleSelectedProdsSaleDisc={handleSelectedProdsSaleDisc}
							handleSelectedProdsCurrency={handleSelectedProdsCurrency}
							handleAddNewProductByISBN={handleAddNewProductByISBN}
							handleUpdateNewProductField={handleUpdateNewProductField}
							form={form}
							getConversionRate={getConversionRate}
						/>
					</Col>



					{/* Bottom: Terms on left, totals on right */}
					<Col span={24} lg={16}>
						<Form.Item name='note' label='Terms'>
							<Input.TextArea rows={6} placeholder='Terms and conditions' />
						</Form.Item>
					</Col>
					<Col span={24} lg={8}>
						<div
							style={{
								padding: "10px 20px",
								display: "flex",
								justifyContent: "space-between",
								border: "1px solid #ccc",
							}}>
							<strong>Total: </strong>
							<strong>Rs. {totalDiscountPaidDue.total}</strong>
						</div>

						{/* Total Product Discount */}
						<div
							style={{
								padding: "10px 20px",
								display: "flex",
								justifyContent: "space-between",
								border: "1px solid #ccc",

							}}>
							<strong>Discount: </strong>
							<strong>Rs. {totalDiscountPaidDue.productDiscount}</strong>
						</div>

						{/* Total After Product Discount */}
						<div
							style={{
								padding: "10px 20px",
								display: "flex",
								justifyContent: "space-between",
								border: "1px solid #ccc",

							}}>
							<strong>After Discount: </strong>
							<strong>Rs. {totalDiscountPaidDue.afterProductDiscount}</strong>
						</div>

						<div
							style={{
								padding: "10px 20px",
								display: "flex",
								justifyContent: "space-between",
								border: "1px solid #ccc",
								alignItems: "center",
							}}>
							<div style={{ marginRight: "15px" }}>
								<strong>Additional Discount: </strong>
							</div>
							<div style={{ display: "flex", gap: "8px" }}>
								<InputNumber
									type="number"
									placeholder="Enter disc Amt"
									addonBefore="Rs."
									onChange={(value) => {
										setDiscountAmount(value || 0);
										setAdditionalDiscount("");
										handleDiscount(value || 0);
									}}
									value={discountAmount}
									style={{ width: "150px" }}
									precision={2}
									step={0.01}
								/>
								<InputNumber
									type="number"
									placeholder="Enter discount %"
									addonAfter="%"
									onChange={(value) => {
										if (value !== '' && value !== null && value !== undefined) {
											setAdditionalDiscount(value);
											setDiscountAmount("");
											handlePercentageDiscount(value);
										} else {
											setAdditionalDiscount("");
											setDiscountAmount("");
											handleDiscount(0);
										}
									}}
									value={additionalDiscount}
									style={{ width: "150px" }}
									precision={2}
									step={0.01}
								/>
							</div>
						</div>

						<div
							style={{
								padding: "10px 20px",
								display: "flex",
								justifyContent: "space-between",
								border: "1px solid #ccc",

							}}>
							<strong>After Add. Discount: </strong>
							<strong>Rs. {totalDiscountPaidDue.afterDiscount}</strong>
						</div>

						{documentType !== 'sales_order' && (
							<>
								{/* Round Off Section */}
								<div
									style={{
										padding: "10px 20px",
										display: "flex",
										justifyContent: "space-between",
										border: "1px solid #ccc",
										alignItems: "center",
									}}>
									<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
										<strong>Round Off: </strong>
										<Form.Item name="round_off_enabled" style={{ margin: 0 }}>
											<Radio.Group
												value={roundOffEnabled}
												onChange={(e) => {
													if (e.target.value === true) {
														handleRoundOff(true, null); // Auto-calculate when enabling
													} else {
														handleRoundOff(false);
													}
												}}
											>
												<Radio value={true}>Enable</Radio>
												<Radio value={false}>Disable</Radio>
											</Radio.Group>
										</Form.Item>
									</div>
									{roundOffEnabled && (
										<InputNumber
											type="number"
											placeholder="Round Off Amount"
											addonBefore="Rs."
											onChange={(value) => handleRoundOff(true, value || 0)}
											value={roundOffAmount}
											style={{ width: "150px" }}
											precision={2}
											step={0.01}
										/>
									)}
								</div>

								<div
									style={{
										padding: "10px 20px",
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										border: "1px solid #ccc",

									}}>
									<strong>Paid Amount: </strong>
									<Form.Item name='paid_amount'>
										<InputNumber type='number' onChange={handlePaid} min={0} placeholder="0" />
									</Form.Item>
								</div>
								<div
									style={{
										padding: "10px 20px",
										display: "flex",
										justifyContent: "space-between",
										border: "1px solid #ccc",
									}}>
									<strong>Due Amount: </strong>
									<strong>Rs. {totalDiscountPaidDue.due}</strong>
								</div>
							</>
						)}
						{/* Total Product Quantity */}
						<div
							style={{
								padding: "10px 20px",
								display: "flex",
								justifyContent: "space-between",
								border: "1px solid #ccc",

							}}>
							<strong>Total Qty: </strong>
							<strong>{totalDiscountPaidDue.totalQty} Copies</strong>
						</div>

						<Form.Item style={{ marginTop: "15px" }}>
							<Popconfirm
								title="Save Invoice"
								description="Are you sure you want to save this invoice?"
								onConfirm={handleSaveInvoiceConfirm}
								okText="Yes"
								cancelText="No">
								<Button block type='primary' htmlType='button' loading={loader}>
									Save Invoice
								</Button>
							</Popconfirm>
						</Form.Item>
					</Col>
				</Row>
			</Form>

			{/* Bill Upload Modal */}
			{showBillUpload && (
				<BillUpload
					onDataExtracted={handleBillDataExtracted}
					onClose={() => setShowBillUpload(false)}
				/>
			)}

			{/* Currency Edit Modal */}
			<Modal
				title="Edit Currency"
				open={currencyEditModalVisible}
				onOk={handleCurrencyFormSubmit}
				onCancel={() => {
					setCurrencyEditModalVisible(false);
					setEditingCurrency(null);
					currencyForm.resetFields();
				}}
				width={600}
				okText="Update"
				cancelText="Cancel"
			>
				<Form
					form={currencyForm}
					layout="vertical"
					name="currencyForm"
				>
					<Form.Item
						label="Currency Name"
						name="name"
						rules={[
							{
								required: true,
								message: "Please enter currency name!",
							},
						]}
					>
						<Input placeholder="Enter currency name" />
					</Form.Item>

					<Form.Item
						label="Symbol"
						name="symbol"
						rules={[
							{
								required: true,
								message: "Please enter currency symbol!",
							},
						]}
					>
						<Input placeholder="Enter currency symbol" />
					</Form.Item>

					<Form.Item
						label="Conversion Rate"
						name="conversion"
						rules={[
							{
								required: true,
								message: "Please enter conversion rate!",
							},
						]}
					>
						<InputNumber
							min={0}
							step={0.01}
							precision={4}
							style={{ width: '100%' }}
							placeholder="Enter conversion rate"
						/>
					</Form.Item>

					<Form.Item
						label="Effective From Date"
						name="effective_from_date"
						tooltip="Currency conversion rate will be effective from this date"
					>
						<DatePicker
							style={{ width: '100%' }}
							format="DD-MMM-YYYY"
							placeholder="Select effective from date"
						/>
					</Form.Item>
				</Form>
			</Modal>

			{/* Add New Customer Modal - from dropdown */}
			<Modal
				title="Add New Customer"
				open={addCustomerModalVisible}
				onCancel={() => setAddCustomerModalVisible(false)}
				footer={null}
				destroyOnClose
				width={480}
			>
				<AddCust
					inModal
					prefilledName={customerSearchValue?.trim() || ''}
					onSuccess={(newCustomer) => {
						if (newCustomer?.id) {
							dispatch(loadAllCustomer({ page: 1, limit: 100 }));
							setCustomer(newCustomer.id);
							form.setFieldsValue({ customer_id: newCustomer.id });
						}
						setCustomerSearchValue('');
						setAddCustomerModalVisible(false);
					}}
					onCancel={() => {
						setAddCustomerModalVisible(false);
						setCustomerSearchValue('');
					}}
				/>
			</Modal>
		</Card>
	);
};

export default AddSale;
